import { User } from "../@core/data/users";

export default class Quiz {
  id?: string;
  type?: string; //radio,check,input,document
  title?: string;
  question?: string;
  answers?: QuizAnswer[];
  valueAnswer?: string;
  resultAnswers?: string[];
  explain?: string;

  //Advance
  tags?: string[];
  published?: boolean;
  publishedOn?: Date;
  privacy?: boolean;
  status?: number;

  //Clone Quiz
  refQuizId?: string;

  noViewer?: number;
  noLiked?: number;
  noComment?: number;

  //Render
  //type, title, question, answers
  //Submit
  submitted?: boolean;
  inputAnswer?: string;
  selectedAnswers?: string[];
  //Return
  isCorrect?: boolean;

  //Save ExerciseUserQuiz
  exerciseUserId?: string;
  exerciseUserQuizId?: string;

  //Summary
  noAttempt?: number;
  noCorrect?: number;
  noIncorrect?: number;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}

export class QuizAnswer {
  type?: string; //text,image,document,video
  value: string;
  content: string;
  selected?: boolean;
  isCorrect?: boolean;
}
